import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-139" data-mp="1ge8rsdhvzxnq">
      <div className="mx-auto max-w-2xl" data-id="element-140" data-mp="2e0zfv8jhomg8">
        <SectionHeading eyebrow="Frequently asked questions" title={<>Your questions, <em className="text-gold-dark" data-id="element-142" data-mp="292ehlensscuf">answered.</em></>} data-id="element-141" data-mp="2dzxw8foeqrmw" />
        <ul className="mt-10 space-y-3" data-id="element-143" data-mp="242a13omw3i47">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-cream ring-1 ring-ink/10" data-id="element-144" data-mp="1z25i9ryiebat" data-mpi={i}>
                <button type="button" className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)} data-id="element-145" data-mp="so6387d6l9tv">
                  <span className="text-[17px] font-bold text-ink" data-id="element-146" data-mp="uey6lspp70jy">{f.q}</span>
                  <PlusIcon className={`h-6 w-6 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-147" data-mp="fj8h3klb05ah" />
                </button>
                <AnimatePresence initial={false} data-id="element-148" data-mp="bhwr3dyipi1r">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-149" data-mp="3syocedb4352g">
                      <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink/75" data-id="element-150" data-mp="3nzbrhy3sw82i">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <SectionCta label="I’m ready — give me access" data-id="element-151" data-mp="1pp32q4nsz49e" />
      </div>
    </section>;
}